import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CloseIcon from '@mui/icons-material/Close';

const ReplacementDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, roleName, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('ReplacementApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Replacement);
                    setInvoicedeatils(response.response_data.ReplacementDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Replacement Details:', error);
            });
    }, [id]);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            Replacement: formData,
            ReplacementDetails: invoicedeatils
        };

        // Validate form data here if needed

        updateData('ReplacementApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/ReplacementIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            let Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            let Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            let GSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.GSTAmount), 0);
            let TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            totalCalculation(Quantity, Amount, GSTAmount, TotalAmount);
        }

    };

    //Items    
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('ReplacementApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            setFormData(prevData => ({
                ...prevData,
                BranchId: branchId,
                CompanyId: companyId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
            });

            setSelectedItem(0);
            //closeModal();

            // Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const GSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.GSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);



            totalCalculation(Quantity, Amount, GSTAmount, TotalAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };


    const totalCalculation = (Quantity, Amount, GSTAmount, TotalAmount) => {

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            Amount: Amount.toFixed(2),
            GSTAmount: GSTAmount,
            TotalAmount: TotalAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';


        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            const quantity = parseFloat(modalData.Quantity) || 0;;
            const rate = parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            const gstAmount = ((amount * (gstrate)) / 100).toFixed(2);

            const totalAmount = (parseFloat(amount) + parseFloat(gstAmount)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                GSTAmount: gstAmount,
                TotalAmount: totalAmount,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
            });
        }
    };

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        const quantity = parseFloat(value) || 0;
        const rate = parseFloat(modalData.Rate) || 0;
        const gstrate = parseFloat(modalData.GSTRate) || 0;
        const amount = (quantity * rate).toFixed(2);
        const gstAmount = ((amount * (modalData.GSTRate)) / 100).toFixed(2);

        const totalAmount = (parseFloat(amount) + parseFloat(gstAmount)).toFixed(2);

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            GSTAmount: gstAmount,
            TotalAmount: totalAmount,
        });
    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };




    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Replacement - Details</h6>

                    <Button
                       
                        component={Link}
                        to="/ReplacementIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>

                </div>

                <div className="pg-watermark">
                    <CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b>
                </div>
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '100%' }}>

                        <div className="w-full mb-4 flex">
                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                        readOnly
                                    />
                                </div>
                            ) : (

                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                        readOnly
                                    />
                                </div>
                            )}



                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>

                            ) : (

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Quantity
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Total Quantity"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Remarks"
                                    name='Remarks'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Amount ? formData.Amount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Amount"
                                    style={{ textAlign: 'right' }}
                                    name='Amount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GST Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GSTAmount ? formData.GSTAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='GSTAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalAmount ? formData.TotalAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Total Amount"
                                    name='TotalAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-full mb-4 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#CDE69A' }}>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A' }}>Item Name</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center' }}>Quantity</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right' }}>Rate</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right' }}>Amount</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right' }}>GST</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right' }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '4px', fontSize: '14px', width: '30%' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center' }}>{invdetail.Quantity}</td>
                                                    <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'right' }}>{invdetail.Rate!== undefined && invdetail.Rate !== null ? invdetail.Rate.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '4px', fontSize: '14px', width: '15%', textAlign: 'right' }}>{invdetail.Amount!== undefined && invdetail.Amount !== null ? invdetail.Amount.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'right' }}>{invdetail.GSTAmount!== undefined && invdetail.GSTAmount !== null ? invdetail.GSTAmount.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '4px', fontSize: '14px', width: '15%', textAlign: 'right' }}>{invdetail.TotalAmount!== undefined && invdetail.TotalAmount !== null ? invdetail.TotalAmount.toFixed(2) : "0.00"}</td>                                                    

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </TableContainer>

                            </div>
                        </div>

                    </div>
                    {
                        isModalOpen && (
                            <div className="w-full mb-4 flex" style={{ marginLeft: '10px', width: '50%', marginTop: '10px' }}>
                                <div className="w-full pr-4">
                                    <div className="bg-teal-800 rounded-lg shadow-lg p-6">
                                        {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                                        <p style={{ color: 'whitesmoke', fontWeight: 'bolder' }}>ADD ITEMS</p>
                                        <div className="w-full mb-4 flex">
                                            <div className="w-4/7 mr-3" style={{ marginLeft: '5px', width: '300px' }}>
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="Weightage">
                                                    Item Name
                                                </label>
                                                <Select
                                                    value={selectedItems}
                                                    onChange={handleItemSelect}
                                                    options={itemsOptions}
                                                    placeholder="Items"
                                                    isSearchable
                                                />

                                            </div>
                                            <div className="w-1/4 mr-3">
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                    Quantity
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                    type="text"
                                                    name="Quantity"
                                                    placeholder="Quantity"
                                                    value={modalData.Quantity}
                                                    onChange={handleModalInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-1/2 mr-4" >
                                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData}>
                                                Add Record
                                            </button>
                                        </div>
                                        <div className="w-1/2 mr-4" style={{ marginLeft: '140px', marginTop: '-40px' }}>
                                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal} >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }


                </div>


            </div >
        </Fragment >

    );
};

export default ReplacementDetails;